<div class="login-wrapper">

	@if (loading) {
		<div class="loading-overlay">
			<mat-spinner />
		</div>
	}

	<mat-card class="login-card">
		<mat-card-header>
			<mat-card-title>Iniciar sesion</mat-card-title>
			<mat-card-subtitle>Accede con tu usuario y contrasena</mat-card-subtitle>
		</mat-card-header>

		<mat-card-content>
			<form class="login-form" (ngSubmit)="login()">
				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Correo</mat-label>
					<input matInput type="email" name="email" [(ngModel)]="email" required />
				</mat-form-field>

				<mat-form-field appearance="outline" class="full-width">
					<mat-label>Contrasena</mat-label>
					<input matInput type="password" name="password" [(ngModel)]="password" required />
				</mat-form-field>

				@if (errorMessage) {
					<p class="error-message">{{ errorMessage }}</p>
				}

				<button mat-flat-button type="submit" class="full-width" [disabled]="loading">
					Ingresar
				</button>
			</form>
		</mat-card-content>
	</mat-card>
</div>
